import _ from "lodash";

export const getPointStatusFields = (
  statusStations,
  dataStations,
  key,
  fields,
  labelCritic,
  labelOk,
  labelWarning,
  isVisitor
) => {
  let baseUrl = "";
  if (typeof window !== "undefined") {
    baseUrl = `${window.location.protocol}//${window.location.host}/dashboard/status-sensors`;
  }

  let listOk = {
    version: "v1",
    info: {
      label: `${key}-ok`,
      id: `${key}-ok`,
    },
    data: {
      id: `${key}-ok`,
      label: `${key}-ok`,
      rows: [],
      fields: fields,
    },
  };

  let listWarning = {
    version: "v1",
    info: {
      label: `${key}-warning`,
      id: `${key}-warning`,
    },
    data: {
      id: `${key}-warning`,
      label: `${key}-warning`,
      rows: [],
      fields: fields,
    },
  };

  let listCritic = {
    version: "v1",
    info: {
      label: `${key}-critico`,
      id: `${key}-critico`,
    },
    data: {
      id: `${key}-critico`,
      label: `${key}-critico`,
      rows: [],
      fields: fields,
    },
  };

  if (statusStations && !_.isEmpty(statusStations) && dataStations && key) {
    statusStations.map((station) => {
      const validStation = _.find(dataStations, function (o) {
        return o.stationId === station.stationId;
      });

      if (_.includes(Object.values(station), -1)) {
        if (validStation) {
          switch (key) {
            case "elenco_poi":
              listCritic.data?.rows.push([
                validStation.stationId,
                validStation.address,
                validStation.coordinates.lat,
                validStation.coordinates.long,
                validStation.cluster,
                labelCritic,
                isVisitor ? '' : `${baseUrl}/${validStation.stationId}`,
              ]);
              break;
            case "PC":
              validStation.peopleCounter &&
                listCritic.data?.rows.push([
                  validStation.stationId,
                  validStation.address,
                  validStation.coordinates.lat,
                  validStation.coordinates.long,
                  validStation.cluster,
                  labelCritic,
                  isVisitor ? '' : `${baseUrl}/${validStation.stationId}`,
                ]);
              break;
            case "base_point":
              validStation.envMonitoring &&
                validStation.envMonitoringType === "base" &&
                listCritic.data?.rows.push([
                  validStation.stationId,
                  validStation.address,
                  validStation.coordinates.lat,
                  validStation.coordinates.long,
                  validStation.cluster,
                  labelCritic,
                  isVisitor ? '' : `${baseUrl}/${validStation.stationId}`,
                ]);
              break;
            case "advanced_point":
              validStation.envMonitoring &&
                validStation.envMonitoringType === "advanced" &&
                listCritic.data?.rows.push([
                  validStation.stationId,
                  validStation.address,
                  validStation.coordinates.lat,
                  validStation.coordinates.long,
                  validStation.cluster,
                  labelCritic,
                  isVisitor ? '' : `${baseUrl}/${validStation.stationId}`,
                ]);
              break;

            default:
              if (validStation[key])
                listCritic.data?.rows.push([
                  validStation.stationId,
                  validStation.address,
                  validStation.coordinates.lat,
                  validStation.coordinates.long,
                  validStation.cluster,
                  labelCritic,
                  isVisitor ? '' : `${baseUrl}/${validStation.stationId}`,
                ]);
              break;
          }
        }
      } else {
        if (_.includes(Object.values(station), 40)) {
          if (validStation) {
            switch (key) {
              case "elenco_poi":
                listCritic.data?.rows.push([
                  validStation.stationId,
                  validStation.address,
                  validStation.coordinates.lat,
                  validStation.coordinates.long,
                  validStation.cluster,
                  labelCritic,
                  isVisitor ? '' : `${baseUrl}/${validStation.stationId}`,
                ]);
                break;
              case "PC":
                validStation.peopleCounter &&
                  listCritic.data?.rows.push([
                    validStation.stationId,
                    validStation.address,
                    validStation.coordinates.lat,
                    validStation.coordinates.long,
                    validStation.cluster,
                    labelCritic,
                    isVisitor ? '' : `${baseUrl}/${validStation.stationId}`,
                  ]);
                break;
              case "base_point":
                validStation.envMonitoring &&
                  validStation.envMonitoringType === "base" &&
                  listCritic.data?.rows.push([
                    validStation.stationId,
                    validStation.address,
                    validStation.coordinates.lat,
                    validStation.coordinates.long,
                    validStation.cluster,
                    labelCritic,
                    isVisitor ? '' : `${baseUrl}/${validStation.stationId}`,
                  ]);
                break;
              case "advanced_point":
                validStation.envMonitoring &&
                  validStation.envMonitoringType === "advanced" &&
                  listCritic.data?.rows.push([
                    validStation.stationId,
                    validStation.address,
                    validStation.coordinates.lat,
                    validStation.coordinates.long,
                    validStation.cluster,
                    labelCritic,
                    isVisitor ? '' : `${baseUrl}/${validStation.stationId}`,
                  ]);
                break;

              default:
                if (validStation[key])
                  listCritic.data?.rows.push([
                    validStation.stationId,
                    validStation.address,
                    validStation.coordinates.lat,
                    validStation.coordinates.long,
                    validStation.cluster,
                    labelCritic,
                    isVisitor ? '' : `${baseUrl}/${validStation.stationId}`,
                  ]);
                break;
            }
          }
        } else {
          if (_.includes(Object.values(station), 30)) {
            if (validStation) {
              switch (key) {
                case "elenco_poi":
                  listWarning.data?.rows.push([
                    validStation.stationId,
                    validStation.address,
                    validStation.coordinates.lat,
                    validStation.coordinates.long,
                    validStation.cluster,
                    labelWarning,
                    isVisitor ? '' : `${baseUrl}/${validStation.stationId}`,
                  ]);
                  break;
                case "PC":
                  validStation.peopleCounter &&
                    listWarning.data?.rows.push([
                      validStation.stationId,
                      validStation.address,
                      validStation.coordinates.lat,
                      validStation.coordinates.long,
                      validStation.cluster,
                      labelWarning,
                      isVisitor ? '' : `${baseUrl}/${validStation.stationId}`,
                    ]);
                  break;
                case "base_point":
                  validStation.envMonitoring &&
                    validStation.envMonitoringType === "base" &&
                    listWarning.data?.rows.push([
                      validStation.stationId,
                      validStation.address,
                      validStation.coordinates.lat,
                      validStation.coordinates.long,
                      validStation.cluster,
                      labelWarning,
                      isVisitor ? '' : `${baseUrl}/${validStation.stationId}`,
                    ]);
                  break;
                case "advanced_point":
                  validStation.envMonitoring &&
                    validStation.envMonitoringType === "advanced" &&
                    listWarning.data?.rows.push([
                      validStation.stationId,
                      validStation.address,
                      validStation.coordinates.lat,
                      validStation.coordinates.long,
                      validStation.cluster,
                      labelWarning,
                      isVisitor ? '' : `${baseUrl}/${validStation.stationId}`,
                    ]);
                  break;
                default:
                  if (validStation[key])
                    listWarning.data?.rows.push([
                      validStation.stationId,
                      validStation.address,
                      validStation.coordinates.lat,
                      validStation.coordinates.long,
                      validStation.cluster,
                      labelWarning,
                      isVisitor ? '' : `${baseUrl}/${validStation.stationId}`,
                    ]);
                  break;
              }
            }
            return station;
          } else {
            if (validStation) {
              switch (key) {
                case "elenco_poi":
                  listOk.data?.rows.push([
                    validStation.stationId,
                    validStation.address,
                    validStation.coordinates.lat,
                    validStation.coordinates.long,
                    validStation.cluster,
                    labelOk,
                    isVisitor ? '' : `${baseUrl}/${validStation.stationId}`,
                  ]);
                  break;
                case "PC":
                  validStation.peopleCounter &&
                    listOk.data?.rows.push([
                      validStation.stationId,
                      validStation.address,
                      validStation.coordinates.lat,
                      validStation.coordinates.long,
                      validStation.cluster,
                      labelOk,
                      isVisitor ? '' : `${baseUrl}/${validStation.stationId}`,
                    ]);
                  break;
                case "base_point":
                  validStation.envMonitoring &&
                    validStation.envMonitoringType === "base" &&
                    listOk.data?.rows.push([
                      validStation.stationId,
                      validStation.address,
                      validStation.coordinates.lat,
                      validStation.coordinates.long,
                      validStation.cluster,
                      labelOk,
                      isVisitor ? '' : `${baseUrl}/${validStation.stationId}`,
                    ]);
                  break;
                case "advanced_point":
                  validStation.envMonitoring &&
                    validStation.envMonitoringType === "advanced" &&
                    listOk.data?.rows.push([
                      validStation.stationId,
                      validStation.address,
                      validStation.coordinates.lat,
                      validStation.coordinates.long,
                      validStation.cluster,
                      labelOk,
                      isVisitor ? '' : `${baseUrl}/${validStation.stationId}`,
                    ]);
                  break;
                default:
                  if (validStation[key])
                    listOk.data?.rows.push([
                      validStation.stationId,
                      validStation.address,
                      validStation.coordinates.lat,
                      validStation.coordinates.long,
                      validStation.cluster,
                      labelOk,
                      isVisitor ? '' : `${baseUrl}/${validStation.stationId}`,
                    ]);
                  break;
              }
            }
            return station;
          }
        }
      }

      return station;
    });
  }

  return [listCritic, listWarning, listOk];
};
